import React from 'react'

const Classes: Record<string, string> = {
    red: 'bg-red-500',
    blue: 'bg-blue-500',
    yellow: 'bg-yellow-500',
}

type Props = {
    color?: string
}

export default function RowIndicator(props: Props) {
    const { color } = props
    if (!color) return null
    let bgClass = Classes[color]

    // let time = new Date(meta.date);
    // if (time < config.start)
    //     return null;
    return <span className={`ml-2 w-2 h-2 mb-1 rounded-full ${bgClass} inline-block`} />
}
